module.exports = __webpack_public_path__ + "img/facebook-l.044d3f45.svg";